/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_LineInputs */

const en_home_intro_line = /** @type {(inputs: Home_Intro_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI systems engineering, based in Latvia.`)
};

const lv_home_intro_line = /** @type {(inputs: Home_Intro_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI sistēmu inženierija Latvijā.`)
};

/**
* | output |
* | --- |
* | "AI systems engineering, based in Latvia." |
*
* @param {Home_Intro_LineInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_intro_line = /** @type {((inputs?: Home_Intro_LineInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_LineInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_intro_line(inputs)
	return en_home_intro_line(inputs)
});